export default "__VITE_ASSET__BEy2nlXq__"